<template>
  <div class="wrapper_dark" @click="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("bifurcation_01_title") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="inner_wrap" :class="{ 'two-cards': isTwoCards }">
      <div v-if="useEmail" class="touch-area email-btn" @click="goInputInfo('email')">
        <img class="icon" src="@/assets/img/email.svg" />
        <div class="title">{{ $tc("bifurcation_02_title_email") }}</div>
        <div class="contents">{{ $tc("bifurcation_04_body_email") }}<br>{{ $tc("bifurcation_05_sub_body_email") }}</div>
        <!-- <div class="sub-contents">{{ $tc("bifurcation_05_sub_body_email") }}</div> -->
        <div class="button">
          <span>{{ $tc("bifurcation_08_select") }}</span>
          <!-- <img src="@/assets/img/arrow_right.svg"/> -->
        </div>
      </div>
      <div class="touch-area phone-btn" @click="goInputInfo('phone')">
        <img class="icon" src="@/assets/img/messenger.svg" />
        <div class="title">{{ $tc("bifurcation_03_title_phone") }}</div>
        <div class="contents">{{ $tc("bifurcation_06_body_phone") }}<br>{{ $tc("bifurcation_07_sub_body_phone") }}</div>
        <!-- <div class="sub-contents">{{ $tc("bifurcation_07_sub_body_phone") }}</div> -->
        <div class="button">
          <span>{{ $tc("bifurcation_08_select") }}</span>
          <!-- <img src="@/assets/img/arrow_right.svg"/> -->
        </div>
      </div>
      <div v-if="useLine" class="touch-area line-btn" @click="goInputInfo('line')">
        <img class="icon" src="@/assets/img/line.svg" />
        <div class="title">{{ $tc("bifurcation_09_title_line") }}</div>
        <div class="contents">{{ $tc("bifurcation_10_body_line") }}<br>{{ $tc("bifurcation_11_sub_body_line") }}</div>
        <div class="button">
          <span>{{ $tc("bifurcation_08_select") }}</span>
        </div>
      </div>
    </div>
    <Popup v-show="showPopup" @popControl="popup" />
    <line-qr-popup :isShow="showLinePopup" @success="lineAuthSuccess" @timeout="lineWaitingTimeout" @close="closeLinePopup" @error="closeLinePopup" />
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>
<script>
import { timeout } from './mixins/timeout'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import Popup from '@/components/Popup.vue'
import LineQrPopup from '@/components/LineQrPopup.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Bifurcation',
  mixins: [timeout],
  components: { timeoutPopup, Popup, LineQrPopup },
  data () {
    return {
      showPopup: false,
      showLinePopup: false,
      isLineQrExpired: false // QR 3분 만료로 timeout 팝업이 뜬 상태인지 여부
    }
  },
  computed: {
    ...mapGetters(
      { restaurant: 'getRestaurantInfo', waitingParams: 'getWaitingParams' }
    ),
    useEmail () {
      return !!(this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.includes('EMAIL'))
    },
    useLine () {
      return !!(this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.includes('LINE'))
    },
    // Phone 카드는 항상 노출되므로 EMAIL/LINE 중 하나만 켜져 있으면 2카드 모드
    isTwoCards () {
      return !(this.useEmail && this.useLine)
    }
  },
  methods: {
    // 선택한 값에 따라 입력페이지 분기 처리
    goInputInfo (type) {
      let path = (this.restaurant.nameRequired) ? '/privacy' : '/phone'
      if (type === 'email') {
        path = '/email'
        this.$store.commit('setWaitingParams', { name: '', phoneNumber: '', menus: new Map(), tempKey: '' })
      } else if (type === 'line') {
        this.$store.commit('setWaitingParams', { name: '', phoneNumber: '', email: '', menus: new Map(), tempKey: '' })
        // QR 노출 3분 동안은 timeout 팝업이 뜨지 않도록 유휴 타이머 정지
        this.stopTimer()
        this.showLinePopup = true
        return
      } else {
        this.$store.commit('setWaitingParams', { email: '', tempKey: '' })
      }
      this.$router.push(path)
    },
    // mixin 메서드 오버라이드
    // LINE 카드 클릭이 루트의 @click까지 버블링되어 stopTimer 직후 setTimer가 다시 호출되는 것을 방지
    interactCheck () {
      if (this.showLinePopup) return
      this.setTimer()
    },
    // LINE 인증 완료(소켓 수신) 시 인원 선택으로 이동
    lineAuthSuccess () {
      this.showLinePopup = false
      this.$router.push('/select-person')
    },
    // QR 노출 3분 만료 시 홈화면 복귀 안내 팝업 노출
    lineWaitingTimeout () {
      this.showLinePopup = false
      this.isLineQrExpired = true
      this.isShowTimeOutPop = true
    },
    // timeout 팝업 '이어서 진행하기' 클릭 시 (mixin 메서드 오버라이드)
    // QR 만료로 뜬 팝업이면 새 QR 재생성, 그 외에는 유휴 타이머 재개
    closeTimeoutPopup () {
      this.isShowTimeOutPop = false
      if (this.isLineQrExpired) {
        this.isLineQrExpired = false
        this.showLinePopup = true // isShow watcher가 open()을 호출해 새 QR 발급
      } else {
        this.setTimer()
      }
    },
    closeLinePopup () {
      this.showLinePopup = false
      this.setTimer()
    },
    back () {
      this.$router.push('/notice')
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";
.inner_wrap {
  display: flex;
  padding: 32px;
  background: $gray_50;
  // 2카드 모드에서는 카드 폭이 넓어 설명이 2줄이면 충분하므로 예약 높이를 줄인다 (TB-14309)
  &.two-cards .touch-area .contents {
    min-height: calc(1.58em * 2);
  }
  .touch-area {
    $touch-area-gap: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include flex-gap($touch-area-gap, column);
    flex: 1 1 0;
    min-width: 0;
    max-height: 670px;
    margin: 0;
    padding: 72px 32px;
    border-radius: 24px;
    border: 2px solid $gray_200;
    background: $white;
    box-shadow: 0px 4px 12px 0px rgba(19, 21, 23, 0.15);
    cursor: pointer;
    &:not(:last-child) {
      margin: 0 20px 0 0;
    }
    .icon {
      width: 100px;
      height: 100px;
      margin: 0 auto;
    }
    .title {
      color: $gray_900;
      text-align: center;
      font-size: 36px;
      font-weight: 700;
      line-height: 1.48;
    }
    .contents {
      // 카드마다 설명 줄 수(2~4줄)가 달라도 정렬이 어긋나지 않도록 4줄 높이를 예약한다
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: calc(1.58em * 4);
      color: $gray_800;
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      line-height: 1.58;
    }
    .sub-contents {
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      color: $indigo;
      line-height: 1.5;
    }
    .button {
      display: flex;
      width: 100%;
      max-width: 500px;
      padding: 28px 10px;
      margin: 0 auto 0;
      margin-top: calc(#{$touch-area-gap} + 28px);
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      background: $light_blue;
      span {
        color: $white;
        text-align: center;
        font-size: 36px;
        font-weight: 700;
        line-height: 1.05;
      }
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // width: 330px;
      // padding: 38px 0;
      // margin: 36px auto 0;
      // font-size: 42px;
      // font-weight: bold;
      // line-height: 1.5;
      // color: $white;
      // background: $cobalt_blue;
      // box-shadow: 0px 6px 12px rgba(18, 56, 255, 0.20);
      // border: 3px solid rgba(19, 21, 23, 0.10);
      // border-radius: 100px;
      // cursor: pointer;
      // span {
      //   padding: 0 12px 0 24px;
      // }
    }
    &.phone-btn {
      .button {
        background: #FFAA00;
      }
    }
    &.line-btn {
      .button {
        background: #06C755;
      }
    }
  }
}
</style>
